import { withStyles } from '@material-ui/core';

import { OpenReportSettingsMenu as OpenReportSettingsMenuComponent } from './component';
import { styles } from './styles';

export const OpenReportSettingsMenu = withStyles(styles)(OpenReportSettingsMenuComponent);
